module.exports = __webpack_public_path__ + "forgot-password.97ad5e44a11f045ef182.svg";


//////////////////
// WEBPACK FOOTER
// C:/unnati/backup/latestWebCode29march/backup17-june-20/src/assets/images/forgot-password.svg
// module id = ../../../../../src/assets/images/forgot-password.svg
// module chunks = main